import serviceTicket from '@/api/customer-service/service-ticket'

import { baseState, baseMutations } from '@/store/mixins'
import { split, isEmpty } from 'lodash'

export const state = {
  ...baseState,
  formViewDatas: [],
  branch_id: [],
  ticket_status_id: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  SET_TICKET_STATUS(state, value) {
    state.ticket_status_id = value
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          branch_id: context.state.branch_id,
          search: context.state.search,
          ticket_status_id: context.state.ticket_status_id,
        }
      },
      attrubutes
    )
    return serviceTicket.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return serviceTicket.store(data)
  },
  update(context, { id, data }) {
    return serviceTicket.update(id, data)
  },
  updateTicketStatus(context, { id, data }) {
    return serviceTicket.updateTicketStatus(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await serviceTicket.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return serviceTicket.destroy(id)
  },
  previewPdf(context, data) {
    return serviceTicket.previewPdf(data)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await serviceTicket.formViewModel({ params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  },
}
